import { MAP_ARENA } from '@/globalVariables'
import { GameType } from '@/globalVariables/gameTypes'

import { StageType } from '@/interfaces/Tutorial'
import type { TutorialStage } from '@/interfaces/Tutorial'

const summerStages: TutorialStage[] = [
  // narative saying you unlocked a new discipline
  {
    id: 62,
    name: 'unlockArcheryNarrative',
    type: StageType.Narrative,
    overlay: false,
    pageName: 'LayoutViewTutorial',
    texts: [],
  },
  // focus on arena building with gsap animation
  {
    id: 63,
    name: 'clickOnArenaBuildingArchery',
    discipline: 12,
    type: StageType.Focus,
    overlay: false,
    pageName: 'LayoutViewTutorial',
    clientId: [MAP_ARENA],
    texts: [],
  },
  // focus on unlocked discipline with overlay and gsap animation
  {
    id: 64,
    name: 'clickOnDisciplineArchery',
    type: StageType.ClientInput,
    overlay: true,
    pageName: 'ArenaViewTutorial',
    clientId: ['arena-discipline-12'],
    discipline: 12,
    texts: [],
  },
]

const winterStages: TutorialStage[] = [
  // narative saying you unlocked a new discipline
  {
    id: 62,
    name: 'unlockBiathlonNarrative',
    type: StageType.Narrative,
    overlay: false,
    pageName: 'LayoutViewTutorial',
    texts: [],
  },
  // focus on arena building with gsap animation
  {
    id: 63,
    name: 'clickOnArenaBuildingBiathlon',
    discipline: 2,
    type: StageType.Focus,
    overlay: false,
    pageName: 'LayoutViewTutorial',
    clientId: [MAP_ARENA],
    texts: [],
  },
  // focus on unlocked discipline with overlay and gsap animation
  {
    id: 64,
    name: 'clickOnDisciplineBiathlon',
    type: StageType.ClientInput,
    overlay: true,
    pageName: 'ArenaViewTutorial',
    clientId: ['arena-discipline-2'],
    discipline: 2,
    texts: [],
  },
]

/**
  Tutorial for discipline unlocked
 */
export default class TutorialUnlockDiscipline2 {
  stages(): TutorialStage[] {
    return window.gameName === GameType.Winter ? winterStages : summerStages
  }
}
